export enum AcceptFileType {
    DOC = '.doc',
    DOCX = '.docx',
    JPEG = '.jpeg',
    JPG = '.jpg',
    PDF = '.pdf',
    PNG = '.png',
    RTF = '.rtf',
}
